import { RouteObject } from "react-router-dom";
import TemplatesLanding from "./landing/landing";
import ChooseTemplates from "./create/templates";
import CreateTemplate from "./create/create";
import TemplateLanding from "./details/landing/landing";

export interface uxTemplatesRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: uxTemplatesRoute[];
}

export const uxTemplatesRoutes: uxTemplatesRoute[] = [
  {
    path: "communication-hub/templates",
    element: <TemplatesLanding />,
  },
  {
    path: "communication-hub/templates/choose",
    element: <ChooseTemplates />,
  },
  {
    path: "communication-hub/templates/:action",
    element: <CreateTemplate />,
  },
  {
    path: "communication-hub/templates/:action/:id",
    element: <CreateTemplate />,
  },
  {
    path: "communication-hub/templates/:action/:id/:name",
    element: <CreateTemplate />,
  },
  {
    path: "communication-hub/templates/view/:id/:name",
    element: <TemplateLanding />,
  },
];
